module.exports = __webpack_public_path__ + "media/newstyle/images/logo-cultura-06a15138b23045bf57b09b5b938cd4af.png";